import { ReactNode } from "react";
import clsx from "clsx";

interface SimpleTableProps {
  data: { label?: string; value: string | ReactNode; className?: any }[];
  col?: number;
}

export function SimpleTable({ data, col = 0 }: SimpleTableProps) {
  let dataMap = null;
  if (col && data.length >= col) {
    dataMap = data
      .map((n, i, arr) => ({ x: n, y: arr[i + 1] }))
      .filter((n, i) => i % 2 === 0);
  }

  return (
    <table>
      <tbody>
        {!dataMap &&
          data.map(({ label, value, className }, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <tr key={`simpleTable-${i}-${label}`}>
              {label && <td className="label">{label}</td>}
              <td className={clsx(["data", className])}>{value}</td>
            </tr>
          ))}

        {dataMap?.map(
          (
            d: {
              x: { value: string | ReactNode };
              y: { value: string | ReactNode };
            },
            i
          ) => (
            // eslint-disable-next-line react/no-array-index-key
            <tr key={`simpleTable-row-${i}`}>
              {Object.values(d)
                .filter((f) => f)
                .map(({ value }, j) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <td className="data" key={`simpleTable-col-${j}`}>
                    {value}
                  </td>
                ))}
            </tr>
          )
        )}
      </tbody>
    </table>
  );
}
